import request from './index'

/** 站内信列表 */
export function fetchMessageList(params = {}) {
  return request.get('/message/list.php', { params })
}

/** 未读数量 */
export function fetchMessageUnread() {
  return request.get('/message/unread.php')
}

/** 标记已读 */
export function markMessageRead(payload) {
  return request.post('/message/read.php', payload)
}

/** 删除消息 */
export function deleteMessageApi(id) {
  return request.post('/message/delete.php', { id })
}
